module.exports = __webpack_public_path__ + "static/hero-dev-51fd7fc78353a78c8831a901db6b2e8f.jpg";